import PropTypes from 'prop-types';
import { Button } from '@arkestro/arkestro-design-system';
import { LeftCircleOutlined, RightCircleOutlined } from '@ant-design/icons';
import style from './ScreenIndicators.module.scss';

const ScreenIndicators = ({ activeStep, stepCount, setCurrentStep }) => {
  const isFirst = activeStep === 0;
  const isLast = activeStep === (stepCount - 1);
  const stepArrForLoop = new Array(stepCount).fill();

  const navigate = direction => {
    if (isFirst && direction === 'back') return;
    if (isLast && direction === 'forward') return;

    const nextStep = direction === 'forward' ? (activeStep + 1) : (activeStep - 1);

    setCurrentStep(nextStep);
  };

  return (
    <div className={style.wrapper}>
      <Button
        icon={<LeftCircleOutlined />}
        onClick={() => navigate('back')}
        style={{ visibility: isFirst ? 'hidden' : 'visible' }}
        type='link'
      />
      <div className={style.indicators}>
        {stepArrForLoop.map((_, i) => {
          const stepStyle = i === activeStep ? style.active : {};

          /* eslint-disable react/no-array-index-key */
          return (
            //  eslint-disable-next-line jsx-a11y/click-events-have-key-events
            <div
              key={i}
              className={`${style.indicator} ${stepStyle}`}
              onClick={() => setCurrentStep(i)}
              role="button"
              tabIndex={0}
            />
          );
          /* eslint-enable react/no-array-index-key */
        })}
      </div>
      <Button
        icon={<RightCircleOutlined />}
        onClick={() => navigate('forward')}
        style={{ visibility: isLast ? 'hidden' : 'visible' }}
        type='link'
      />
    </div>
  );
};

ScreenIndicators.propTypes = {
  activeStep: PropTypes.number.isRequired,
  setCurrentStep: PropTypes.func.isRequired,
  stepCount: PropTypes.number.isRequired
};

export default ScreenIndicators;
